<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="this.shipmentForm.orderStep == 3 ? '修改订单发货信息': '订单发货'"
    width="500px"
    @close="close"
  >
  <el-form :model="shipmentForm" label-width="80px">
    <el-form-item label="订单号">
      {{ shipmentForm.orderNo }}
    </el-form-item>
    <el-form-item label="物流公司">
      <el-select
        clearable
        filterable
        v-model="shipmentForm.companyName"
        placeholder="请选择物流公司"
      >
        <el-option
          v-for="(item, index) in express"
          :key="index"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="物流单号">
      <el-input
        v-model="shipmentForm.shipOrderNo"
        placeholder="请输入物流单号"
        class="fix-width"
      ></el-input>
    </el-form-item>
    <el-form-item label="发货时间">
      <el-date-picker
        v-model="shipmentForm.shipTime"
        type="datetime"
        placeholder="选择发货时间"
        value-format="YYYY-MM-DD HH:mm:ss"
      />
    </el-form-item>
  </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="shipOrder">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import lodash from 'lodash'
import { express } from '@/utils/express'
import {
  getProductOrder,
  verifyProductOrder,
  refundProductOrder,
  shipProductOrder,
  updateOrder
} from '@/api/order'

  export default {
    name: 'ProductOrderExpress',
    emits: ['fetch-data'],
    data() {
      return {
        moment,
        express,
        profile: '',
        shipmentForm: {
          orderId: '',
          companyName: '',
          shipOrderNo: '',
          shipTime: '',
          orderStep: '',
        },
        rules: {
        },
        dialogFormVisible: false,
      }
    },
    methods: {
      show(row) {
        this.shipmentForm = Object.assign(
          {},
          {
            orderId: row.orderId,
            orderNo: row.basic && row.basic.orderNo,
            companyName: row.basic && row.basic.shipInfo && row.basic.shipInfo.companyName || '',
            shipOrderNo: row.basic && row.basic.shipInfo && row.basic.shipInfo.shipOrderNo || '',
            shipTime: moment(row.extra && row.extra.shipTime).format('yyyy-MM-DD HH:mm:ss'),
            orderStep: row.step,
          }
        )
        this.dialogFormVisible = true
      },
      close() {
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      async shipOrder() {
        if (!this.shipmentForm.companyName || !this.shipmentForm.shipOrderNo) {
          this.$message.error('物流信息不能为空！')
          return
        }
        if (!this.shipmentForm.shipTime) {
          this.$message.error('请选择发货时间！')
          return
        }
        this.shipLoading = true
        if(this.shipmentForm.orderStep != 3){
          shipProductOrder(this.shipmentForm)
          .then((res) => {
            if (!res) return
            this.shipVisible = false
            this.dialogFormVisible = false
            this.$message.success('发货成功！')
            this.$emit('fetch-data')
          })
          .finally(() => {
            this.shipLoading = false
          })
        }else {
          updateOrder(this.shipmentForm)
          .then((res) => {
            if (!res) return
            this.show({orderId:this.shipmentForm.orderId})
            this.shipVisible = false
            this.dialogFormVisible = false
            this.$message.success('更新收货信息成功！')
            this.$emit('fetch-data')
          })
          .finally(() => {
            this.shipLoading = false
          })
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.fix-width {
  width: 220px;
}
</style>
